// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Paper settings modal — themed to the app dark navy (audit polish). */
.ZK0f_tohGVQ2oz8yD884 {
  position: fixed;
  inset: 0;
  background: rgba(3, 6, 12, 0.6);
  display: grid;
  place-items: center;
  z-index: 1000;
  padding: 16px;
}

.lceWGBVO2X8_3aCRfqAL {
  width: min(520px, calc(100vw - 32px));
  max-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  background: var(--vnsc-bg-secondary, #0f1521);
  color: var(--vnsc-text-primary, #e6edf3);
  border: 1px solid var(--vnsc-border, #1e2635);
  border-radius: 12px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.55);
  font-size: 13px;
}

.NUEzLLk69XfmiklUbOO2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid var(--vnsc-border, #1e2635);
  font-weight: 600;
  font-size: 15px;
  flex-shrink: 0;
}

.Lbv9iwhNWfxcG7wFTHlS {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: var(--vnsc-text-secondary, #8a94a6);
  cursor: pointer;
}

.Lbv9iwhNWfxcG7wFTHlS:hover {
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.06));
  color: var(--vnsc-text-primary, #e6edf3);
}

.Z4P25LIqYbija7LVvHZr {
  padding: 16px 18px;
  overflow-y: auto;
  overflow-x: hidden;
  display: grid;
  gap: 14px;
  min-height: 0;
  min-width: 0;
}

.xP0lc1sBjhIinFAPHcDw {
  overflow-x: auto;
  scrollbar-width: none;
}

.xP0lc1sBjhIinFAPHcDw::-webkit-scrollbar {
  display: none;
}

.xP0lc1sBjhIinFAPHcDw button {
  flex: none;
  white-space: nowrap;
}

.xP0lc1sBjhIinFAPHcDw button[aria-selected="true"] {
  color: #fff;
  box-shadow: inset 0 -2px 0 var(--vnsc-accent, #2f6df6);
}

.kjGBx3MbkDDUfpAQQevV {
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.kjGBx3MbkDDUfpAQQevV > * {
  min-width: 0;
}

.kjGBx3MbkDDUfpAQQevV > span:first-child {
  color: var(--vnsc-text-secondary, #8a94a6);
}

.AXZUYxyRekLxHZWfVtmv {
  grid-column: 2;
  font-size: 11px;
  color: var(--vnsc-text-secondary, #8a94a6);
  margin-top: -8px;
}

.fcRACf4ZbcZH2kbBbx3j {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.fcRACf4ZbcZH2kbBbx3j input {
  width: 16px;
  height: 16px;
  accent-color: var(--vnsc-accent, #2f6df6);
  flex-shrink: 0;
  margin: 0;
}

.XjlWibuAc3DReBEPep0Z {
  grid-column: 2;
  font-size: 11px;
  color: var(--vnsc-color-bearish, #e5484d);
  margin-top: -8px;
}

.XtmDV5a2TMLpCRsjxAgz {
  display: inline-flex;
  background: var(--vnsc-bg-primary, #0b0f17);
  border: 1px solid var(--vnsc-border, #1e2635);
  border-radius: 8px;
  padding: 2px;
  gap: 2px;
}

.XtmDV5a2TMLpCRsjxAgz button {
  all: unset;
  cursor: pointer;
  padding: 6px 14px;
  border-radius: 6px;
  color: var(--vnsc-text-secondary, #8a94a6);
  border: 1px solid transparent;
  transition: color 0.15s, background 0.15s, border-color 0.15s;
  font-size: 12px;
  white-space: nowrap;
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

.XtmDV5a2TMLpCRsjxAgz button:hover {
  color: var(--vnsc-text-primary, #e6edf3);
}

.XtmDV5a2TMLpCRsjxAgz button[aria-pressed="true"] {
  background: var(--vnsc-accent-soft, rgba(47, 109, 246, 0.16));
  border-color: var(--vnsc-accent, #2f6df6);
  color: #fff;
}

.XtmDV5a2TMLpCRsjxAgz button:focus-visible {
  outline: 2px solid var(--vnsc-accent, #2f6df6);
  outline-offset: 1px;
}

.G5pJVQHUkAvlca6nlPZQ {
  display: flex;
  align-items: center;
  background: var(--vnsc-bg-primary, #0b0f17);
  border: 1px solid var(--vnsc-border, #1e2635);
  border-radius: 6px;
  min-width: 0;
}

.G5pJVQHUkAvlca6nlPZQ:focus-within {
  border-color: var(--vnsc-accent, #2f6df6);
  box-shadow: 0 0 0 3px var(--vnsc-accent-soft, rgba(47, 109, 246, 0.16));
}

.G5pJVQHUkAvlca6nlPZQ input {
  all: unset;
  flex: 1;
  min-width: 0;
  padding: 7px 10px;
  font-variant-numeric: tabular-nums;
  color: var(--vnsc-text-primary, #e6edf3);
}

.G5pJVQHUkAvlca6nlPZQ span {
  padding: 0 10px;
  color: var(--vnsc-text-secondary, #8a94a6);
  white-space: nowrap;
}

.zILYi0_1ibApXp5KLgDO {
  position: sticky;
  bottom: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid var(--vnsc-border, #1e2635);
  background: var(--vnsc-bg-secondary, #0f1521);
  border-radius: 0 0 12px 12px;
  flex-shrink: 0;
}

.k2Kd3R48rTPdCaTCvXtd {
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid var(--vnsc-border, #1e2635);
  background: transparent;
  color: var(--vnsc-text-primary, #e6edf3);
  cursor: pointer;
  font-size: 13px;
}

.k2Kd3R48rTPdCaTCvXtd:hover {
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.06));
}

.PQq8t59Tu0XMLIojEp1S {
  background: var(--vnsc-accent, #2f6df6);
  border-color: var(--vnsc-accent, #2f6df6);
  color: #fff;
  font-weight: 600;
}

.PQq8t59Tu0XMLIojEp1S:hover {
  background: var(--vnsc-accent, #2f6df6);
  filter: brightness(1.1);
}

.PQq8t59Tu0XMLIojEp1S:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  filter: none;
}

.Mo17rlQYRd6a57_n7eIp {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/widget/trading/panel/PaperSettingsModal.module.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,6CAA6C;EAC7C,wCAAwC;EACxC,6CAA6C;EAC7C,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,oDAAoD;EACpD,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,2DAA2D;EAC3D,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,6BAA6B;EAC7B,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6DAA6D;EAC7D,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,uEAAuE;AACzE;;AAEA;EACE,UAAU;EACV,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iDAAiD;EACjD,6CAA6C;EAC7C,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,6CAA6C;EAC7C,uBAAuB;EACvB,wCAAwC;EACxC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,OAAO;AACT","sourcesContent":["/* Paper settings modal — themed to the app dark navy (audit polish). */\r\n.backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(3, 6, 12, 0.6);\r\n  display: grid;\r\n  place-items: center;\r\n  z-index: 1000;\r\n  padding: 16px;\r\n}\r\n\r\n.modal {\r\n  width: min(520px, calc(100vw - 32px));\r\n  max-height: calc(100vh - 64px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: var(--vnsc-bg-secondary, #0f1521);\r\n  color: var(--vnsc-text-primary, #e6edf3);\r\n  border: 1px solid var(--vnsc-border, #1e2635);\r\n  border-radius: 12px;\r\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.55);\r\n  font-size: 13px;\r\n}\r\n\r\n.head {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 14px 18px;\r\n  border-bottom: 1px solid var(--vnsc-border, #1e2635);\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.closeBtn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 6px;\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary, #8a94a6);\r\n  cursor: pointer;\r\n}\r\n\r\n.closeBtn:hover {\r\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.06));\r\n  color: var(--vnsc-text-primary, #e6edf3);\r\n}\r\n\r\n.body {\r\n  padding: 16px 18px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  display: grid;\r\n  gap: 14px;\r\n  min-height: 0;\r\n  min-width: 0;\r\n}\r\n\r\n.tablist {\r\n  overflow-x: auto;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.tablist::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.tablist button {\r\n  flex: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n.tablist button[aria-selected=\"true\"] {\r\n  color: #fff;\r\n  box-shadow: inset 0 -2px 0 var(--vnsc-accent, #2f6df6);\r\n}\r\n\r\n.row {\r\n  display: grid;\r\n  grid-template-columns: 160px minmax(0, 1fr);\r\n  align-items: center;\r\n  gap: 12px;\r\n  min-width: 0;\r\n}\r\n\r\n.row > * {\r\n  min-width: 0;\r\n}\r\n\r\n.row > span:first-child {\r\n  color: var(--vnsc-text-secondary, #8a94a6);\r\n}\r\n\r\n.hint {\r\n  grid-column: 2;\r\n  font-size: 11px;\r\n  color: var(--vnsc-text-secondary, #8a94a6);\r\n  margin-top: -8px;\r\n}\r\n\r\n.checkRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.checkRow input {\r\n  width: 16px;\r\n  height: 16px;\r\n  accent-color: var(--vnsc-accent, #2f6df6);\r\n  flex-shrink: 0;\r\n  margin: 0;\r\n}\r\n\r\n.error {\r\n  grid-column: 2;\r\n  font-size: 11px;\r\n  color: var(--vnsc-color-bearish, #e5484d);\r\n  margin-top: -8px;\r\n}\r\n\r\n.seg {\r\n  display: inline-flex;\r\n  background: var(--vnsc-bg-primary, #0b0f17);\r\n  border: 1px solid var(--vnsc-border, #1e2635);\r\n  border-radius: 8px;\r\n  padding: 2px;\r\n  gap: 2px;\r\n}\r\n\r\n.seg button {\r\n  all: unset;\r\n  cursor: pointer;\r\n  padding: 6px 14px;\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-secondary, #8a94a6);\r\n  border: 1px solid transparent;\r\n  transition: color 0.15s, background 0.15s, border-color 0.15s;\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n  flex: 1 1 0;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  text-align: center;\r\n}\r\n\r\n.seg button:hover {\r\n  color: var(--vnsc-text-primary, #e6edf3);\r\n}\r\n\r\n.seg button[aria-pressed=\"true\"] {\r\n  background: var(--vnsc-accent-soft, rgba(47, 109, 246, 0.16));\r\n  border-color: var(--vnsc-accent, #2f6df6);\r\n  color: #fff;\r\n}\r\n\r\n.seg button:focus-visible {\r\n  outline: 2px solid var(--vnsc-accent, #2f6df6);\r\n  outline-offset: 1px;\r\n}\r\n\r\n.field {\r\n  display: flex;\r\n  align-items: center;\r\n  background: var(--vnsc-bg-primary, #0b0f17);\r\n  border: 1px solid var(--vnsc-border, #1e2635);\r\n  border-radius: 6px;\r\n  min-width: 0;\r\n}\r\n\r\n.field:focus-within {\r\n  border-color: var(--vnsc-accent, #2f6df6);\r\n  box-shadow: 0 0 0 3px var(--vnsc-accent-soft, rgba(47, 109, 246, 0.16));\r\n}\r\n\r\n.field input {\r\n  all: unset;\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding: 7px 10px;\r\n  font-variant-numeric: tabular-nums;\r\n  color: var(--vnsc-text-primary, #e6edf3);\r\n}\r\n\r\n.field span {\r\n  padding: 0 10px;\r\n  color: var(--vnsc-text-secondary, #8a94a6);\r\n  white-space: nowrap;\r\n}\r\n\r\n.foot {\r\n  position: sticky;\r\n  bottom: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 12px 18px;\r\n  border-top: 1px solid var(--vnsc-border, #1e2635);\r\n  background: var(--vnsc-bg-secondary, #0f1521);\r\n  border-radius: 0 0 12px 12px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.btn {\r\n  padding: 8px 16px;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--vnsc-border, #1e2635);\r\n  background: transparent;\r\n  color: var(--vnsc-text-primary, #e6edf3);\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n}\r\n\r\n.btn:hover {\r\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.06));\r\n}\r\n\r\n.btnPrimary {\r\n  background: var(--vnsc-accent, #2f6df6);\r\n  border-color: var(--vnsc-accent, #2f6df6);\r\n  color: #fff;\r\n  font-weight: 600;\r\n}\r\n\r\n.btnPrimary:hover {\r\n  background: var(--vnsc-accent, #2f6df6);\r\n  filter: brightness(1.1);\r\n}\r\n\r\n.btnPrimary:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n  filter: none;\r\n}\r\n\r\n.footSpacer {\r\n  flex: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `ZK0f_tohGVQ2oz8yD884`,
	"modal": `lceWGBVO2X8_3aCRfqAL`,
	"head": `NUEzLLk69XfmiklUbOO2`,
	"closeBtn": `Lbv9iwhNWfxcG7wFTHlS`,
	"body": `Z4P25LIqYbija7LVvHZr`,
	"tablist": `xP0lc1sBjhIinFAPHcDw`,
	"row": `kjGBx3MbkDDUfpAQQevV`,
	"hint": `AXZUYxyRekLxHZWfVtmv`,
	"checkRow": `fcRACf4ZbcZH2kbBbx3j`,
	"error": `XjlWibuAc3DReBEPep0Z`,
	"seg": `XtmDV5a2TMLpCRsjxAgz`,
	"field": `G5pJVQHUkAvlca6nlPZQ`,
	"foot": `zILYi0_1ibApXp5KLgDO`,
	"btn": `k2Kd3R48rTPdCaTCvXtd`,
	"btnPrimary": `PQq8t59Tu0XMLIojEp1S`,
	"footSpacer": `Mo17rlQYRd6a57_n7eIp`
};
export default ___CSS_LOADER_EXPORT___;
